import React, { useMemo } from 'react';
import { ToggleButtonGroup, Typography } from '@pinwheel/origami';
import { useOpts } from '../../../context';
import AmountInput from './AmountInput';
import PercentageInput from './PercentageInput';
import usePartialSwitchToggle from './hooks/usePartialSwitchToggle';
import { useGetLocalizedString } from '../../../hooks/useGetLocalizedString';
import { checkHackyWorkspace } from '../../../utils/hacky-workspace-customizations';
import { selectLinkTokenPayload } from '../../../state/slices/slice-link-params';
import { useAppSelector } from '../../../state';
function Remainder() {
    var getLocalizedString = useGetLocalizedString();
    return (React.createElement(Typography, { variant: "caption", align: "center", color: {
            type: 'theme',
            colorLegacy: 'Primary/70',
            colorNext: 'neutral/default',
        } }, getLocalizedString('REMAINDER_DISCLAIMER')));
}
var getDefaultSelection = function (apr) {
    return apr === 'amount'
        ? { action: 'partial_switch', allocation: { type: 'amount', value: null } }
        : apr === 'percentage'
            ? {
                action: 'partial_switch',
                allocation: { type: 'percentage', value: null },
            }
            : { action: 'partial_switch', allocation: { type: 'remainder' } };
};
function PartialSwitchToggle() {
    var _a = useOpts(), amountSelection = _a.amountSelection, setAmountSelection = _a.setAmountSelection;
    var _b = usePartialSwitchToggle(), options = _b.options, value = _b.value;
    var linkTokenPayload = useAppSelector(selectLinkTokenPayload);
    var workspaceName = linkTokenPayload === null || linkTokenPayload === void 0 ? void 0 : linkTokenPayload.workspaceName;
    var body = useMemo(function () {
        var _a, _b;
        if ((amountSelection === null || amountSelection === void 0 ? void 0 : amountSelection.action) === 'full_switch')
            return null;
        if (((_a = amountSelection === null || amountSelection === void 0 ? void 0 : amountSelection.allocation) === null || _a === void 0 ? void 0 : _a.type) === 'amount')
            return React.createElement(AmountInput, null);
        if (((_b = amountSelection === null || amountSelection === void 0 ? void 0 : amountSelection.allocation) === null || _b === void 0 ? void 0 : _b.type) === 'percentage')
            return React.createElement(PercentageInput, null);
        return React.createElement(Remainder, null);
    }, [amountSelection]);
    var isRobinhood = checkHackyWorkspace('Robinhood', workspaceName);
    // Returns null for if toggle should be invisible
    if (!body)
        return body;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: { margin: '16px 0 0', width: '100%' } },
            React.createElement(ToggleButtonGroup, { eventId: "FullSwitchAndMore-partialToggle", options: options, value: value, role: "tablist", onChange: function (option) {
                    return setAmountSelection(getDefaultSelection(option.value));
                }, includeBorder: !isRobinhood })),
        body));
}
export default PartialSwitchToggle;
